import { createContext } from "react";

type SearchContextType = {
  selected: null | any;
  updateSelected: (selected: any) => void;
  filters?: any[];

  portfolio?: any;
  searchType?: any;
  location?: any;
  sizeMeasurementType?: any;
  forSale?: any;
  bids?: any;
  dxStats?: any;
  totalOtherLocations?: any
}

const defaultContext: SearchContextType = {
  selected: null,
  updateSelected: (selection) => {}
}

const SearchContext = createContext(defaultContext);
export default SearchContext;